import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface FiltersWrapperProps {
  children: React.ReactNode
  className?: string
}

export const FiltersWrapper: React.FC<FiltersWrapperProps> = ({ children, className }) => {
  return (
    <Box paddingBottom="s16">
      <Box background="white" className={`${'FiltersWrapper_stickyFilters'} ${className || ''}`}>
        {children}
      </Box>
    </Box>
  )
}
